import styled from 'styled-components';
import { FaBars, FaWindowMaximize } from 'react-icons/fa';
import { VscLayoutSidebarRight } from 'react-icons/vsc';

export const LayoutSelectorContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const LayoutSelectorContent = styled.div`
  align-items: stretch;
  display: flex;
  gap: 0.25rem;
  height: 3.75rem;
  padding: 0.25rem;
`;

export const Dropdown = styled.div`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  position: absolute;
  background-color: white;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  top: 40px;
  right: 0;
  border-radius: 4px;
  overflow: hidden;
`;

export const DropdownItem = styled.button`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: none;
  background: ${(props) => (props.selected ? props.selectedColor : 'none')};
  cursor: pointer;
  padding: 0.5rem;
  width: 100%;
  min-width: 5rem;
  max-width: 5rem;
  border-radius: 0.25rem;

  &:hover {
    background-color: ${(props) =>
      props.selected ? props.selectedColor : '#f1f1f1'};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  span {
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    margin-top: 0.25rem;
    white-space: nowrap;
    color: #525f7f;
  }
`;

export const IconButton = styled.button`
  background: ${(props) => (props.isActive ? '#f1f1f1' : 'none')};
  border: none;
  cursor: pointer;
  padding: 8px;
  font-size: 16px;
  border-radius: 0.25rem;

  &:hover {
    background-color: #f1f1f1;
  }
`;

export const LayoutIcon = styled.div`
  display: flex;
  align-items: center;
  svg {
    font-size: 20px;
    color: ${(props) => props.color};
  }
`;

export const FaBarsIcon = styled(FaBars)`
  font-size: 20px;
  color: ${(props) => props.color};
`;

export const FaWindowMaximizeIcon = styled(FaWindowMaximize)`
  font-size: 20px;
  color: ${(props) => props.color};
`;

export const FaColumnsIcon = styled(VscLayoutSidebarRight)`
  font-size: 20px;
  color: ${(props) => props.color};
`;
